import { ConfigEffects } from "./config";
import { PatientEffects } from "./patient";
import { StaffMemberTreatmentEffects } from "./staff.effects";

export const EffectsList = [
    PatientEffects,
    ConfigEffects,
    StaffMemberTreatmentEffects
];